export default __webpack_public_path__ + "static/media/hero.decd6e52.png";